import { createRoute, redirect } from '@tanstack/react-router'
import { t } from 'i18next'

import { DynamicRouteParameterWPrefix, StaticRouteParameter } from 'config/routing'
import { mediaPlatformsRoute } from 'pages/NWPlatform/MediaPlatforms/Routing'

export const mediaPlatformRoute = createRoute({
  getParentRoute: () => mediaPlatformsRoute,
  path: DynamicRouteParameterWPrefix.PLATFORM_ID,
  beforeLoad: ({ location, params: { platformId } }) => {
    if (location.pathname.endsWith(platformId) || location.pathname.endsWith(`${platformId}/`)) {
      throw redirect({
        replace: true,
        from: mediaPlatformRoute.fullPath,
        to: StaticRouteParameter.ASSETS,
      })
    }
  },
  loader: () => ({
    crumb: {
      title: t('entity:publishing.mediaPlatform', { count: 1 }),
    },
  }),
})
